import { createSelector } from "@ngrx/store";
import { SelectSupplierModuleState } from "../suppliermodule.selector";


export const SelectBankCountries = (supplierCode: string) => createSelector(
    SelectSupplierModuleState,
    state => state.BankState.bankCountries ? state.BankState.bankCountries?.find(x => x.key == supplierCode)?.value || [] : []
);